// Structural mirror of the WorkflowDto fields this utility reads — keeps
// src/app/ callers (WorkflowCreateButton) from depending on the generated
// API client. Real WorkflowDto instances satisfy this shape automatically.
export interface IWorkflowAuthorizationSource {
  authorizedRoles?: { organizationRoleId?: number | null }[] | null;
  authorizedUsers?: { jobUser?: { userId?: number | null } | null }[] | null;
  excludedUsers?: { jobUser?: { userId?: number | null } | null }[] | null;
}

export interface WorkflowPermissions {
  allowedRoles: number[];
  allowedUsers: number[];
  blockedUsers: number[];
}

export const getWorkflowPermissions = (
  workflow?: IWorkflowAuthorizationSource | null,
): WorkflowPermissions => ({
  allowedRoles:
    workflow?.authorizedRoles
      ?.map((r) => r.organizationRoleId)
      .filter((x): x is number => x != null) ?? [],
  allowedUsers:
    workflow?.authorizedUsers
      ?.map((u) => u.jobUser?.userId)
      .filter((x): x is number => x != null) ?? [],
  blockedUsers:
    workflow?.excludedUsers
      ?.map((u) => u.jobUser?.userId)
      .filter((x): x is number => x != null) ?? [],
});
